module.exports = __webpack_public_path__ + "static/media/brand-logo--black.f71a51c1.png";